import { useState } from 'react'
import AuthService from 'services/auth'
import MaskedInputService from 'services/maskedInput'
import Select from 'components/Inputs/Select'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import AddPictureModal from 'pages/Modals/AddPictureModal'
import cutileiLogo from 'icons/cutilei-logo.png'
import ReactTooltip from 'react-tooltip'
import professionalPersonalValidator from 'validators/professionalPersonalValidator'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  SubTitle,
  FormField,
  ImageContainer,
  Picture,
  Label,
  InfoText,
  WarningText,
  Input,
  MaskedInput,
  Row
} from '../styles'

export default function PersonalInfoForm ({
  professionalData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [showPictureDialog, setShowPictureDialog] = useState (false)
  const businessId = AuthService.getBusinessId ()

  const togglePictureDialog = () => setShowPictureDialog (!showPictureDialog)

  return (
    <Formik
      validationSchema={professionalPersonalValidator}
      validateOnChange={false}
      validateOnBlur={true}
      initialValues={{
        'business_id': businessId,
        'profile_picture': professionalData.profile_picture,
        'name': professionalData.name,
        'nickname': professionalData.nickname,
        'cpf': professionalData.cpf,
        'email': professionalData.email,
        'birth': professionalData.birth,
        'gender': professionalData.gender,
        'phone': professionalData.phone
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => {
        const handleChangePicture = newPictureUrl => {
          setFieldValue ('profile_picture', newPictureUrl)
        }

        return (
          <Form onKeyDown={submitOnEnter(handleSubmit)} style={{width: 680}}>
            <SubTitle>Dados pessoais</SubTitle>
            <FormField style={{marginBottom: 20}}>
              <ImageContainer onClick={togglePictureDialog}>
                <Picture src={values.profile_picture?.url ?? cutileiLogo}/>
              </ImageContainer>
              <SubTitle>Foto de perfil</SubTitle>
              <InfoText>
                Essa foto será exibida no app dos membros da <b>Cutilei</b> e em sua agenda.
              </InfoText>
            </FormField>
            <Row>
              <FormField stretch={6}>
                <Input
                  placeholder='Nome completo'
                  value={values.name}
                  onChange={handleChange ('name')}
                  onBlur={handleBlur ('name')}
                />
                {touched.name && errors.name && (
                  <WarningText>{errors.name}</WarningText>
                )}
              </FormField>
              <FormField stretch={4}>
                <Input
                  placeholder='Nome que aparecerá na agenda'
                  value={values.nickname}
                  onChange={handleChange ('nickname')}
                  onBlur={handleBlur ('nickname')}
                  data-for='nickname'
                  data-tip
                />
                <ReactTooltip id='nickname' effect='solid' backgroundColor='#252525' tooltipRadius='10'>
                  <Label style={{color: '#FFFFFF'}}>
                    Este é o nome que aparecerá na agenda do salão e para os clientes. <br/>
                    Se o campo não for preenchido, o primeiro nome será usado.
                  </Label>
                </ReactTooltip>
                {touched.nickname && errors.nickname && (
                  <WarningText>{errors.nickname}</WarningText>
                )}
              </FormField>
            </Row>
            <Row>
              <FormField stretch={2}>
                <Input
                  type='email'
                  autoComplete='off'
                  placeholder='E-mail'
                  value={values.email}
                  onChange={handleChange ('email')}
                  onBlur={handleBlur ('email')}
                />
                {touched.email && errors.email && (
                  <WarningText>{errors.email}</WarningText>
                )}
              </FormField>
              <FormField>
                <MaskedInput
                  name='cpf'
                  placeholder='CPF'
                  options={{
                    blocks: [3,3,3,2],
                    delimiters: ['.', '.', '-'],
                    numericOnly: true
                  }}
                  value={values.cpf}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('cpf')}
                />
                {touched.cpf && errors.cpf && (
                  <WarningText>{errors.cpf}</WarningText>
                )}
              </FormField>
              <FormField>
                <MaskedInput
                  name='phone'
                  placeholder='Celular'
                  options={{
                    blocks: [0, 2, 5, 4],
                    delimiters: ['(', ') ', '-'],
                    numericOnly: true,
                  }}
                  value={values.phone}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('phone')}
                />
                {touched.phone && errors.phone && (
                  <WarningText>{errors.phone}</WarningText>
                )}
              </FormField>
            </Row>
            <Row style={{width: '60%', alignSelf: 'center'}}>
              <FormField>
                <MaskedInput
                  name='birth'
                  placeholder='Nascimento'
                  options={{date: true, datePattern: ['d', 'm', 'Y']}}
                  value={values.birth}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('birth')}
                />
                {touched.birth && errors.birth && (
                  <WarningText>{errors.birth}</WarningText>
                )}
              </FormField>
              <FormField>
                <Select
                  name='gender'
                  placeholder='Gênero...'
                  value={values.gender}
                  options={[
                    {label: 'Masculino', value: 'Masculino'},
                    {label: 'Feminino', value: 'Feminino'},
                    {label: 'Não informar', value: 'Não informar'}
                  ]}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  error={errors.gender}
                  touched={touched.gender}
                />
                {touched.gender && errors.gender && (
                  <WarningText>{errors.gender}</WarningText>
                )}
              </FormField>
            </Row>
            <AddPictureModal
              title='Adicioanr foto de perfil'
              visible={showPictureDialog}
              currentImage={values.profile_picture?.url ?? cutileiLogo}
              onConfirm={handleChangePicture}
              onClose={togglePictureDialog}
            />
            <MainButton
              leftIcon={<MdNavigateNext size={30}/>}
              aria-label='Próximo'
              onClick={handleSubmit}
              width={60}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
